const zh = {
  meta: {
    base: '《苍翼：混沌效应》官方网站'
  },
  nav: {
    home: "主页",
    role: "角色",
    video: "视频",
    announcement: "重要公告",
    guide: "内容创作指南"
  },
  role: {
    playerWarning: "你的浏览器不支持video标签,请换一个浏览器试试。",
    rg: {
      name: "拉格纳",
      intro: "施放技能会消耗生命值，而对敌人造成伤害后又能恢复生命值，生命值越低，伤害越高，恢复效果越强。只要能避开致命的攻击，他的力量将得到完全的释放。"
    },
    a: {
      name: "Λ-No.11-",
      intro: "可以控制背后的剑刃或从虚空中召唤剑刃进行攻击。虽然在前期有攻击能力不足的短板，但激发关键潜能后，可从各处召唤剑刃。不断发射的剑刃会撕碎所有阻挡她的敌人。"
    },
    hk: {
      name: "白面",
      intro: "移动速度较慢，但具有极高的攻击力和防护力，擅长弹反。发动技能格挡敌人的正面攻击后，可以使出毁灭性的招式。不断磨练弹反，甚至能够在零倒地的情况下通关。"
    },
    hb: {
      name: "琥珀响音",
      intro: "会使用各种武器发起攻击，并且能够将影子作为攻击手段。从背后发起攻击时造成的伤害会大幅提升，要想最大程度发挥这一优势，就必须注意调整和敌人的位置关系。"
    },
    nol: {
      name: "诺爱儿",
      intro: "可以使用双枪进行不同方式的射击，同时借助枪的后坐力在空中灵活地位移和攻击。将各种攻击技能运用自如后，可通过在战斗中巧妙组合这些技能，无所顾忌地横冲直撞。"
    },
    kk: {
      name: "九重",
      intro: "可以使用各种武装进行高速移动、展开狂轰滥炸、设置机关。解锁核心潜能后，使用武装还能设置陷阱。基于武装可以扩展出更为丰富的战斗方式。"
    },
    ma: {
      name: "枣麻衣",
      intro: "可使用长枪进行突刺、投掷攻击乃至卷起旋风。激发潜能后，能够进行连续突刺，投掷攻击会更灵活，旋风会有更大的范围。由于附带位移的招式较多，需要注意不要冲到危险中。"
    },
    es: {
      name: "Es",
      intro: "以轻盈的姿态挥舞大剑，释放纹章进行攻击。纹章也具有攻击判定，激发相关核心潜能可使纹章更大更华丽，呈现出花绽全场的战斗效果。"
    },
    tk: {
      name: "桃儿卡卡",
      intro: "拥有很高的机动性和连续性；擅长横冲直撞，同时还能旋转对敌；可以产生分身与本尊一起攻击。"
    },
    rc: {
      name: "雷其儿",
      intro: "能够使唤仆从发动攻击，同时也能够召唤闪电与飓风并在战场上优雅的舞动。"
    },
    jn: {
      name: "如月琴恩",
      intro: "可令敌人减速乃至将其冻结。解锁相关潜能后，拔剑的动作可以格挡攻击，并在格挡成功时对敌人产生额外的攻击，而在收剑瞬间立即出招，可以使出强化招式。只要准确把握出招时机，就能发挥其强大实力。"
    },
    hzm: {
      name: "哈札马",
      intro: "主要使用匕首进行近身作战，能够使用锁链拉近自身与敌人的距离或是快速移动。在获取潜能后能使用各种攻击吸收敌人的MP。"
    },
    // icey: {
    //     name: "艾希",
    //     intro: "来自于异界的少女，能够使用太刀释放各种华丽的斩击，在对敌人造成一定伤害后，还能够进行强力追击；对机械类敌人能够造成额外伤害。"
    // }
    bl: {
      name: "芭烈特",
      intro: "一个擅长打击与投技的角色，可以从多个角度抓取敌人发动攻击，并使用手甲发动炮击。在获取潜能后，不仅能够进入强化状态，还能够从远距离快速突进抓取敌人发动攻击。"
    },
    nt: {
      name: "黑铁直人",
      intro: "一名擅长近身格斗作战的角色，可以释放血液转化为各种武器作战。在获取潜能后，不仅能够进入大幅强化战斗能力的特殊状态，还可以通过冲刺与蓄力强化自身的所有攻击动作。"
    },
    ph: {
      name: "白金",
      intro: "轻快华丽地使用多种魔法和武器发起攻击，大量招式具有难以预测的随机效果。获取潜能后，魔法和武器都有概率获得强化，但运气不好时就会出现失误。"
    }
  },
  news: {
    more: "查看更多",
    slider: [
      {
        title: '',
        img: require("@/assets/images/news-slider3-zh.jpg"),
        content: ''
      },
      {
        title: '冲击动作巅峰！超爽动作肉鸽Steam全球发售——《苍翼：混沌效应》',
        img: require("@/assets/images/news-slider1-zh.jpg"),
        content: '<p>《苍翼：混沌效应》已在Steam全球发售，售价68元，首周折扣12%，ACE世界正式连接！</p><p>《苍翼：混沌效应》是由经典格斗IP苍翼默示录官方授权、91Act开发的2D横板动作肉鸽游戏。基于格斗游戏演变而来的全新动作肉鸽，天花板品质的2D动作战斗体验，每个角色完全独立的动作设计，可深度定制组合的、千变万化的角色动作系统！</p><p>点击下方商店链接立即下载，体验极致畅快的2D动作战斗吧！</p><p>Steam商店页：<a href="https://store.steampowered.com/app/2273430">https://store.steampowered.com/app/2273430</a></p><p>官方Q群：928900991</p><p>BiliBili：<a href="https://space.bilibili.com/1663803541">https://space.bilibili.com/1663803541</a></p>'
      },
      {
        title: '《苍翼：混沌效应》首发常见问题解答',
        img: require("@/assets/images/news-slider2-zh.jpg"),
        content: '<p>Q：游戏什么时候发售，售价是多少？</br>A：将于8月16日10:00在Steam全球发售，国区定价68元人民币，首周折扣12%。</p><p>Q：游戏的发售版本有多少内容？</br>A：发售版本游戏的内容量如下：</br>·4组大型主题关卡+1个随机生成的类银河城地图</br>·7位风格迥异的角色和100+角色可选潜能</br>·8种元素体系和200+元素构建策略</br>·10名拥有独特机制的BOSS+50+种不同特色的敌人</br>·所有BOSS形态机制全面进化的进阶挑战模式</br>·成熟独特的剧情表演形式</br>我们希望给出足够丰富的、有诚意的内容，让大家既能体验到这款游戏的魅力，又能值回票价！</p><p>Q：发售后，未来的更新计划是？</br>A：我们计划于9月和11月分别免费更新两次DLC，追加新角色和新剧情。同时在2024年的Q1发布正式版，包括完整的多分支多结局剧情、更多的可操控角色、以及新的游玩模式。</p><p>Q：游戏支持的语言有哪些？</br>A：发售版本在所有地区均完全支持中文语音。同时支持简体中文、英语及日语文本。</p><p>Q：游戏支持的系统以及最低配置？</br>A：同时支持Windows和MacOS系统，为保证游玩流畅度，Windows最低配置建议在Intel Core i3/4 GB RAM/GTX 950及以上，MacOS最低配置建议在MacBook Pro 2018及以上。</p><p>Q：游戏运行推荐的分辨率是？</br>A：推荐在2560*1440（2K）分辨率下运行。</p><p>Q：游戏是否适配手柄和Steam Deck？</br>A：完全适配手柄，在游戏内设置可以自由切换键鼠或手柄，并可以自定义调整键位。游戏也可以在Steam Deck上流畅运行。</p><p>Q：游戏是否支持多人游玩？</br>A：发售版本仅支持单人游玩，暂时没有本地或在线联机内容。</p><p>Q：“迭代测试”获得的兑换码奖励可以在游戏中使用吗？</br>AA：兑换码可以在这次的PC版中使用，但需要在正式版上线后才能兑换，正式版计划于2024年Q1发布。</p><p>Q：如何找到官方资讯和交流平台？</br>你可以关注我们的Steam商店，同时我们也在各大社群建立了官方交流阵地，非常欢迎玩家们加入和我们交流。<br/>官方QQ群：928900991<br/>BiliBili：<a href="https://space.bilibili.com/1663803541">https://space.bilibili.com/1663803541</a> </p><p>Q：如何联系官方人员反馈建议？</br>A：你可以通过上述的社群渠道联络我们，如果你希望更高效实时地和官方人员沟通，强烈推荐加入官方QQ群/Discord。</p>'
      }
    ],
    url: [
      {
        title: "海外独立游戏展会上，这款国产新星让外媒惊艳",
        url: "https://www.tgbus.com/news/208015"
      },
      {
        title: "海外独立游戏展会上的国产新星，游戏出海究竟能有多少种可能",
        url: "https://www.gameweibo.com/article-619892.html",
      },
      {
        title: "《苍翼：混沌效应》抢先评测：更适合动作宝宝体质的肉鸽游戏",
        url: "https://www.3dmgame.com/score/3743068.html",
      },
      {
        title: "国产作品如何在海外独立游戏展上取得好成绩？",
        url: "http://www.chuapp.com/?c=Article&a=index&id=289428",
      }
    ]
  },
  announcement: {
    publishTime: "2026.02.12",
    title: "《苍翼：混沌效应X》实体版首日补丁更新重要公告",
    subTitle: "",
    content: "<p>由于《苍翼：混沌效应X》PS5及NS实体版中部分游戏内容及性能和稳定性优化，需要通过首日补丁网络更新的形式获得，其中也包括了角色【黑铁直人】及游戏模式【极限区域】。因此请购买了《苍翼：混沌效应X》实体版游戏的用户，及时连接网络下载首日补丁更新，以获得完整的游戏体验。</p><br /><p><strong style=\"color: red;\">【特别提醒】</strong></p><br /><p>在未进行首日补丁网络更新前，使用《苍翼：混沌效应X》实体版游戏保存的游戏存档，在更新后的版本中运行，可能会出现剧情模式进程无法推进的问题。如果出现这一情况，您可能需要使用更新后的版本重新建立存档重新开始游戏，方可恢复正常的剧情推进。</p><br /><p>因此，我们强烈推荐各位购买了实体版游戏的用户，请务必先进行首日补丁网络更新再进行游玩，以获得最佳的游戏体验。</p><br /><p>感谢您的配合与理解！</p>"
  },
  guide: {
    title: "《苍翼：混沌效应X》直播与内容创作指南",
    content: `
    <p style="line-height: 1.8;">各位主播与内容创作者们：</p>
    <p>感谢你们对游玩和创作《苍翼：混沌效应X》内容的兴趣。</p>
    <p>《苍翼：混沌效应X》是一款由 Astrolabe Games 发行，91Act 开发的动作肉鸽游戏，拥有精美的 2D 画面、多样化的动作表现，以及注重用户体验的出色操控手感。游戏中将出现源自《苍翼》（BLAZBLUE）系列中的多名经典角色，以及由 Arc System Works 监修制作的全新原创剧情。</p>
    <p>在遵守本“《苍翼：混沌效应X》直播与内容创作指南”（以下简称“本指南”）的前提下，用户可以在网站、博客、各类社交媒体平台，或是 YouTube、bilibili、Twitch 以及 niconico 动画等内容共享平台发布或传播，包含 Astrolabe Games 游戏（以下简称“本公司”）所发行的《苍翼：混沌效应X》的视频（含直播）和图像（以下统称“发布”）。</p>
    <p>但无论本指南内容如何，若用户使用游戏主机或平台提供的标准分享功能进行发布，均视为获得许可。</p>
    <p>我们希望您能尽情享受《苍翼：混沌效应X》本身，以及创作与分享内容的乐趣。</p>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">直播素材包</span>
      </li>
    </ul>
    <p style="padding-left: 20px">我们为《苍翼：混沌效应X》的直播和投稿准备了官方素材包。在进行创作内容时，欢迎使用这些素材。</p>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>素材下载地址：<a href='https://pan.baidu.com/share/init?surl=HWuTtVMyYJmizqVMDcfXog&pwd=ASTL' target='_blank' style='color: #87CEEB; text-decoration: underline;'>https://pan.baidu.com/share/init?surl=HWuTtVMyYJmizqVMDcfXog&pwd=ASTL</a></li>
    </ul>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">版权信息的标注</span>
      </li>
    </ul>
    <p style="padding-left: 20px">在发布或直播《苍翼：混沌效应X》时，请在视频简介等易于察觉的位置包含以下信息：</p>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>游戏名称：《苍翼：混沌效应X》</li>
      <li>开发者：91Act</li>
      <li>发行商：Astrolabe Games</li>
    </ul>
    <p style="padding-left: 20px;">若由于字数限制等原因无法完整标注，请使用英文版权信息：</p>
    <p style="padding-left: 20px;">© ARC SYSTEM WORKS/© 91Act/© Astrolabe Games</p>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">适用本指南的用户</span>
      </li>
    </ul>
    <p style="padding-left: 20px">本指南面向个人用户，不适用于公司或其他组织。</p>
    <br />
    <ul style='list-style-type: none; position: relative;'>
      <li style="position: relative; padding-left: 18px; margin: 8px 0;">
        <span style="position: absolute; left: 0; top: 6px; width: 12px; height: 12px; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 2px;">许可的发布内容</span>
      </li>
    </ul>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>根据本指南，仅限使用《苍翼：混沌效应X》正式版所创作的发布内容。</li>
      <li>关于数字游戏：仅允许发布由用户本人亲自游玩，并通过屏幕捕获、截图等方式记录的视频或图像，且须同时配有实况解说或个人心得等评论。此外，禁止发布通过篡改游戏程序或游戏内容（包括使用模组 MOD）所制作的视频及图像。</li>
      <li>本指南不涵盖包含第三方作品内容的发布，即便该内容是本公司与第三方合作在游戏中使用的角色、插画、音乐、音乐数据等。</li>
      <li>若发布内容涉及本公司以外第三方的知识产权，需另行获得该权利人的许可。本公司无法回答有关此类权利归属的咨询。</li>
    </ul>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">允许发布的平台</span>
      </li>
    </ul>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>由个人管理的非营利性网站和博客。</li>
      <li>YouTube、bilibili、Twitch、niconico动画及其他内容共享平台，以及各类社交媒体。</li>
      <li>评论/测评网站等。</li>
      <li>进行发布时，请另行遵守各内容共享平台和社交媒体平台的使用条款及指南。</li>
    </ul>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">商业或营利性目的的发布</span>
      </li>
    </ul>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>原则上禁止出于商业或营利性目的的发布。</li>
      <li>但是，允许利用各社交媒体平台及内容共享平台的内容收益功能获利。</li>
    </ul>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">关于剧透</span>
      </li>
    </ul>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>发布的视频内容若涉及核心场景、重大事件或故事情节，请在标题、描述或显著位置标注“含剧透”等字样。此外，在其他情况下也请注意避免剧透。</li>
    </ul>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">禁止事项</span>
      </li>
    </ul>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>发布违反法律法规或公共秩序良俗的内容。</li>
      <li>发布包含可能伤害他人或令他人反感的表达方式的内容（如歧视性言论、诽谤、侵犯隐私、煽动或鼓励犯罪等）。</li>
      <li>以政治活动、政治诉求、宗教活动，以及为本公司以外产品进行促销或广告为目的的发布。</li>
      <li>发布泄露游戏中非公开数据的内容，或涉及作弊、修改存档等违规行为的内容。</li>
      <li>发布贬低本公司品牌价值、本公司游戏或第三方形象的内容。</li>
      <li>发布可能误导观众认为本公司赞同或认可该发布内容的内容。</li>
      <li>发布侵犯第三方知识产权的内容。</li>
      <li>发布阻碍本公司游戏正常提供与运营的内容。</li>
      <li>发布改动或改编本公司游戏角色或故事情节的内容。</li>
      <li>发布仅包含游戏内过场动画或事件静态图的内容。</li>
      <li>发布仅包含游戏音频（如配音、背景音乐或音效）的内容。</li>
      <li>本公司认定的可能属于上述任何禁止行为的内容。</li>
    </ul>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">其他注意事项</span>
      </li>
    </ul>
    <ul style='list-style-type: disc; padding-left: 40px;'>
      <li>本指南并不代表本公司对用户根据本指南所发布内容的认可或赞同。</li>
      <li>本指南仅规定了本公司游戏作品的使用条件。对于用户因根据本指南发布内容而与第三方产生的任何纠纷，本公司概不负责。</li>
      <li>本公司有权要求用户删除、停止或限制本公司认为违反本指南的发布内容。</li>
      <li>若用户未遵守上述要求或给本公司造成损失，本公司可能会禁止该用户进行发布或要求赔偿损失。</li>
      <li>本公司有权自行决定以任何理由更改或暂停本指南。若更改前的发布内容因指南变更而产生违规，本公司可能会根据变更后的指南要求用户删除此类内容。</li>
    </ul>
    <br />
    <ul style='list-style-type: none; margin: 0;'>
      <li style="display: flex; align-items: center; margin: 0.5em 0; line-height: 1.5;">
        <span style="width: 0.75em; height: 0.75em; background-color: #fff; display: inline-block;"></span>
        <span style="margin-left: 0.5em;">联系方式</span>
      </li>
    </ul>
    <p style="padding-left: 20px">如有关于本指南的任何疑问，请通过以下电子邮箱与我们联系：</p>
    <p style="padding-left: 20px">Contact@Astrolabe-Games.com</p>
    <br />
    <p style='text-align: right; margin-right: 150px;'>2026年2月11日</p>
    <p style='text-align: right; margin-right: 150px;'>Astrolabe Games</p>
    `
  }
}
export default zh
